import React, { useState } from 'react';
import MovimientosDesktop from './Desktop';

import useMovimientos from 'newHooks/useMovimientos';
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import Loading from 'components/Loading'


export default function Movimientos() {
    const {
        respMovements,
        cargos,
        abonos,
        setPeriod,
        errorCode,
        loading
    } = useMovimientos();

    const [ data, setData ] = useState()

    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                <MovimientosDesktop respMovements={respMovements} cargos={cargos} abonos={abonos} setPeriod={setPeriod} errorCode={errorCode}/>
                { loading && <Loading /> }
            </CreditoLayout>
        </MainLayout>
    )
}